/**
 * The words around every "Request this add-on" button (2026-10-28, Saumil + Nilay).
 *
 * WHY: practices read "Request to Enable" as a switch, then wrote to us expecting the feature to
 * be on. A request only emails Teamio; Teamio turns the feature on after the practice agrees to
 * what it includes and costs. This file is the one place that says so, for every surface.
 *
 * Keep this IMPORT-FREE: node-tests execute this exact file.
 * Never put a price, a vendor cost or jargon in here (Documents/CLAUDE.md: customer-facing content).
 */

export const FEATURE_REQUEST_BUTTON_TEXT = 'Request this add-on';
export const FEATURE_REQUEST_TAG = 'Add-on';
export const FEATURE_REQUEST_SENT_TEXT = 'Request received. Not turned on yet.';

// Texting and email are "not set up yet" (a number / verified sender is missing), which a plan may
// include, so they get that lead instead of calling them optional (catalog: lib/feature-catalog.js).
export const SETUP_FEATURE_KEYS = Object.freeze(['SMS', 'EMAIL']);

const OPTIONAL_LEAD = 'This is an optional add-on to your plan.';
const SETUP_LEAD = 'Not set up on your plan yet.';
const SAME_FOR_ALL = "Requesting it doesn't turn it on. Our team will contact you to go over what's included and the cost, and it's enabled only after you agree.";

/** @param {string} featureKey a key in myaccount-service/lib/feature-catalog.js */
export function featureRequestNote(featureKey) {
  const lead = SETUP_FEATURE_KEYS.includes(featureKey) ? SETUP_LEAD : OPTIONAL_LEAD;
  return `${lead} ${SAME_FOR_ALL}`;
}

// The same promises in one short sentence, for the few cards with a FIXED height (the dashboard's
// preview widgets are ~200px tall and clip anything longer). Used ONLY where the full note cannot fit.
// No lead: the "Add-on" tag beside it already says what it is.
const SHORT_NOTE = "Requesting it doesn't turn it on. We'll contact you about the cost first.";

/** The key is accepted so the two wordings share one call shape; the short one is the same for all. */
export function featureRequestNoteShort(featureKey) {
  return SHORT_NOTE;
}
